import React from "react";

const Header = ({ data }) => {
  if (!data) {
    return null;
  }

  const profileImage = `images/${data.image}`;
  const highlights = data.highlights || [];
  const networks = (data.social || []).map((network) => (
    <a
      key={network.name}
      className="social-link"
      href={network.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={network.name}
    >
      <i className={network.className} aria-hidden="true" />
    </a>
  ));

  return (
    <header
      id="home"
      className="site-hero"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero-code-interface.jpg)`,
      }}
    >
      <nav className="site-nav" aria-label="Primary navigation">
        <a className="brand" href="#home" aria-label="Ezekiel Oladele home">
          <span className="brand-mark">EO</span>
          <span className="brand-name">Ezekiel Oladele</span>
        </a>

        <div className="nav-links">
          <a href="#work">Work</a>
          <a href="#experience">Experience</a>
          <a href="#skills">Capabilities</a>
          <a href="#contact">Contact</a>
        </div>
      </nav>

      <div className="hero-shell">
        <div className="hero-copy-wrap hero-animate">
          <p className="eyebrow">{data.occupation}</p>
          <h1>{data.headline}</h1>
          <p className="hero-copy">
            {data.description} Based in {data.address.city}, Nigeria.
          </p>

          <div className="hero-actions">
            <a className="button button-primary" href="#contact">
              Start a conversation
            </a>
            <a
              className="button button-secondary"
              href={data.resumedownload}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download CV
            </a>
          </div>

          <div className="hero-meta">
            <span className="status-dot" aria-hidden="true" />
            {data.availability}
          </div>

          <div className="hero-social" aria-label="Social profiles">
            {networks}
          </div>
        </div>

        <div className="hero-portrait-wrap hero-portrait-animate">
          <div className="hero-portrait-frame">
            <img src={profileImage} alt="Ezekiel Oladele" />
            <span className="portrait-label">Lagos, Nigeria</span>
          </div>
          <div className="hero-role-note">
            <span>Currently leading</span>
            <strong>Payments, wallets, and product systems</strong>
          </div>
        </div>
      </div>

      <div className="proof-strip hero-proof-animate" aria-label="Career highlights">
        {highlights.map((highlight, index) => (
          <div
            className="proof-item"
            key={highlight.label}
            style={{ "--reveal-delay": `${index * 100}ms` }}
          >
            <strong>{highlight.value}</strong>
            <span>{highlight.label}</span>
          </div>
        ))}
      </div>
    </header>
  );
};

export default Header;
